import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setAndSearchVenueCode } from '../../Actions/actions';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { useLoadScript } from '@react-google-maps/api';
import SummaryContainer from '../../Containers/SummaryContainer';
import BreadcrumbsContainer from '../../Containers/BreadcrumbsContainer';
import VenueContainer from '../../Containers/VenueContainer';
import BasicCoverageContainer from '../../Containers/BasicCoverageContainer';
import EventContainer from '../../Containers/EventContainer';
import AdditionalCoveragesContainer from '../../Containers/AdditionalCoveragesContainer';
import InsuredContainer from '../../Containers/InsuredContainer';
import InsuranceContactContainer from '../../Containers/InsuranceContactContainer';
import PaymentInformationContainer from '../../Containers/PaymentInformationContainer';
import EventSelectContainer from '../../Containers/EventSelectContainer';
import EventSelectSecondaryContainer from '../../Containers/EventSelectSecondaryContainer';
import ReferralBannerContainer from '../../Containers/ReferralBannerContainer';
import QuoteLoader from '../QuoteLoader/QuoteLoader';

const partOneScrollTo = (ref) => {
  if (!ref || !ref.current) return;
  if (isMobile) {
    const currentPos = window.scrollY;
    setTimeout(() => {
      const scrollToPosition =
        currentPos > ref.current.offsetTop
          ? ref.current.offsetTop - 150
          : ref.current.offsetTop;

      window.scrollTo({
        left: 0,
        top: scrollToPosition,
        behavior: 'smooth',
      });
    }, 300);
  }
};

const libraries = ['places'];

const Form = ({
  showFormPartOne,
  showFormPartTwo,
  mobileDisplay,
  summHeight,
  mobileShow,
  hasReferralBanner,
  showQuotePage,
}) => {
  const basicCoverageRef = useRef(null);
  const aboutEventRef = useRef(null);
  const additionalCoverageRef = useRef(null);
  const insuranceContactRef = useRef(null);
  const paymentInfoRef = useRef(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
    language: 'en',
  });

  const location = useRef(useLocation()).current;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoaded && location.search) {
      dispatch(setAndSearchVenueCode(location.search));
    }
  }, [isLoaded, location, dispatch]);

  return (
    isLoaded && (
      <>
        <ReferralBannerContainer />
        <BreadcrumbsContainer />
        {showQuotePage && !showFormPartOne && !showFormPartTwo && (
          <QuoteLoader />
        )}
        {!showQuotePage &&
          mobileDisplay &&
          !showFormPartOne &&
          !showFormPartTwo && (
            <div className="eventSelect">
              <div className="card--main">
                <EventSelectContainer />
                <EventSelectSecondaryContainer />
              </div>
            </div>
          )}
        <div className="container-main">
          <form className="row">
            <div className="col-lg order-1 order-lg-0">
              {!showQuotePage && !mobileDisplay && (
                <div className="eventSelect">
                  <div className="eventSelect card--width-lg card--main">
                    <EventSelectContainer />
                    <EventSelectSecondaryContainer />
                  </div>
                </div>
              )}

              <div className="container-main__inner">
                <div
                  className="summary__spacer"
                  style={{
                    height: `${
                      hasReferralBanner ? summHeight + 25 + 43 : summHeight + 25
                    }px`,
                  }}
                />
                {showFormPartOne && (
                  <>
                    <VenueContainer
                      basicCoverageRef={basicCoverageRef}
                      scrollToPosition={partOneScrollTo}
                    />
                    <BasicCoverageContainer
                      basicCoverageRef={basicCoverageRef}
                      aboutEventRef={aboutEventRef}
                      scrollToPosition={partOneScrollTo}
                    />
                    <EventContainer
                      aboutEventRef={aboutEventRef}
                      additionalCoverageRef={additionalCoverageRef}
                      scrollToPosition={partOneScrollTo}
                    />
                    <AdditionalCoveragesContainer
                      additionalCoverageRef={additionalCoverageRef}
                    />
                  </>
                )}
                {showFormPartTwo && (
                  <>
                    <InsuredContainer
                      insuranceContactRef={insuranceContactRef}
                      scrollToPosition={partOneScrollTo}
                    />
                    <InsuranceContactContainer
                      insuranceContactRef={insuranceContactRef}
                      paymentInfoRef={paymentInfoRef}
                      scrollToPosition={partOneScrollTo}
                    />
                    <PaymentInformationContainer
                      paymentInfoRef={paymentInfoRef}
                    />
                  </>
                )}
              </div>
            </div>
            {(showFormPartOne || showFormPartTwo) && (
              <div
                className={`col-lg-auto order-0 order-lg-1 summary__col ${
                  hasReferralBanner ? 'summary__col--ref-banner' : ''
                } ${!mobileShow ? 'summary-hide' : ''}`}
              >
                <div className="container-main__inner summary__container">
                  <SummaryContainer />
                </div>
              </div>
            )}
          </form>
        </div>
      </>
    )
  );
};
Form.propTypes = {
  mobileDisplay: PropTypes.bool.isRequired,
  showFormPartOne: PropTypes.bool.isRequired,
  showFormPartTwo: PropTypes.bool.isRequired,
  summHeight: PropTypes.number.isRequired,
  mobileShow: PropTypes.bool.isRequired,
  hasReferralBanner: PropTypes.bool.isRequired,
  showQuotePage: PropTypes.bool.isRequired,
};

export default Form;
